export default __webpack_public_path__ + "static/media/OasisMap.5b83b8c2.jpg";